export function serializeBigInts(obj: unknown): unknown {
  return JSON.parse(JSON.stringify(obj, (_key, value) => (typeof value === "bigint" ? value.toString() : value)));
}
